// src/components/Admin/Auth/ResetPasswordForm.js
import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Auth } from '../../../../api/auth';
import { toast, ToastContainer } from 'react-toastify';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import './AuthForms.scss';
import { logoEduca } from '../../../../assets';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export function ResetPasswordForm() {
  const [loading, setLoading] = useState(false);
  const token = useQuery().get('token');
  const navigate = useNavigate();
  const authController = new Auth();

  useEffect(() => {
    if (!token) {
      toast.error('Token no válido.');
      navigate('/auth');
    }
  }, [token, navigate]);

  const formik = useFormik({
    initialValues: { password: '', confirm: '' },
    validationSchema: Yup.object({
      password: Yup.string().min(6, 'Mínimo 6 caracteres').required('Requerido'),
      confirm:  Yup.string()
                  .oneOf([Yup.ref('password')], 'Deben coincidir')
                  .required('Requerido'),
    }),
    onSubmit: async ({ password }) => {
      try {
        setLoading(true);
        await authController.resetPassword(token, password);
        toast.success('Contraseña actualizada.');
        setTimeout(() => navigate('/auth'), 1500);
      } catch (err) {
        toast.error(err.message || 'Error al restablecer');
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="auth-container">
      <div className="auth-card">
        <img src={logoEduca.logoE360} alt="Educa360" className="auth-logo" />

        <ToastContainer />
        <form className="auth-form" onSubmit={formik.handleSubmit}>
          <div className="input-group">
            <input
              name="password"
              type="password"
              placeholder="Nueva contraseña"
              className="input-pill"
              onChange={formik.handleChange}
              value={formik.values.password}
            />
            {formik.touched.password && formik.errors.password && (
              <div className="field-error">{formik.errors.password}</div>
            )}
          </div>

          <div className="input-group">
            <input
              name="confirm"
              type="password"
              placeholder="Repite contraseña"
              className="input-pill"
              onChange={formik.handleChange}
              value={formik.values.confirm}
            />
            {formik.touched.confirm && formik.errors.confirm && (
              <div className="field-error">{formik.errors.confirm}</div>
            )}
          </div>

          <button type="submit" className="btn-pill" disabled={loading}>
            {loading ? 'Restableciendo...' : 'Restablecer contraseña'}
          </button>
        </form>

        <div className="auth-switch" style={{ marginTop: '1rem' }}>
          <Link to="/auth" className="link-btn">
            ← Volver a iniciar sesión
          </Link>
        </div>
      </div>
    </div>
  );
}
